module.exports = __webpack_public_path__ + "img/UBQ-alt.2e7ab002.svg";